module.exports = __webpack_public_path__ + "img/head.32191385.png";